import React from 'react';

export const BufferLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <div className="w-8 h-8 flex items-center justify-center">
    <svg
      {...props}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      <rect width="100" height="100" rx="18" fill="#231F20" />
      <rect x="22" y="30" width="56" height="9" rx="4.5" fill="white" />
      <rect x="22" y="46" width="56" height="9" rx="4.5" fill="white" />
      <rect x="22" y="62" width="56" height="9" rx="4.5" fill="white" />
    </svg>
  </div>
);
